import { Block as BlockIcon } from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { RequisitesStatusDetails } from 'enums';
import { TranslationNamespace } from 'i18n';
import { User } from 'types';
import { formatUtils } from 'utils';

type Props = {
  statusDetails?: RequisitesStatusDetails;
  blockedMessage?: string;
  blockedBy?: Partial<User>;
  blockedAt?: string;
  blockedUntilAt?: string;
};

export const RequisitesBlocked: React.FC<Props> = ({
  statusDetails,
  blockedMessage,
  blockedBy,
  blockedAt,
  blockedUntilAt,
}) => {
  const { t } = useTranslation(TranslationNamespace.Common);

  const tooltipTitle = useMemo(() => {
    let title = t('requisites_status.blocked');
    const message = t(`requisites_status_details.${statusDetails!}`);
    return statusDetails ? `${title}: ${message}` : title;
  }, [statusDetails, t]);

  const tooltipDate = useMemo(
    () =>
      blockedAt
        ? `${t('common.date')}: ${formatUtils.formatDate(blockedAt)}`
        : null,
    [blockedAt, t],
  );

  const tooltipUnblockDate = useMemo(
    () =>
      blockedUntilAt
        ? `${t('common.unblock')}: ${formatUtils.formatDate(blockedUntilAt)}`
        : null,
    [blockedUntilAt, t],
  );

  const tooltipContent = useMemo(
    () => (
      <div>
        <div>{tooltipTitle}</div>
        {blockedBy && <div>{blockedBy.name}</div>}
        {blockedMessage && <div>{blockedMessage}</div>}
        {tooltipDate && <div>{tooltipDate}</div>}
        {tooltipUnblockDate && <div>{tooltipUnblockDate}</div>}
      </div>
    ),
    [blockedMessage, blockedBy, tooltipDate, tooltipUnblockDate, tooltipTitle],
  );

  return (
    <Tooltip title={tooltipContent}>
      <BlockIcon color="error" className="tw-mx-2" />
    </Tooltip>
  );
};
